export { default as Hero } from './Hero'
export { getHeroData } from './fractals'
